/**
 * @license @tabler/icons-vue v3.34.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconOvalFilled = createVueComponent("filled", "oval-filled", "IconOvalFilled", [["path", { "d": "M12 2c3.972 0 7 4.542 7 10s-3.028 10 -7 10c-3.9 0 -6.89 -4.379 -6.997 -9.703l-.003 -.297l.003 -.297c.107 -5.323 3.097 -9.703 6.997 -9.703z", "key": "svg-0" }]]);

export { IconOvalFilled as default };
//# sourceMappingURL=IconOvalFilled.mjs.map
